(function () {
    'use strict';

    angular
        .module('BCMControllers')
        .controller('BIAProfileListController', Controller);

    Controller.$inject = ['topBarService'];

    function Controller(topBarService) {
        // topBarService.setTitleAndIcon('Procedures', 'fa fa-book');
        topBarService.setTopBar({
            title1: 'Business Continuity Analysis',
            icon1: 'fa fa-umbrella'
        });
    }
})();
